import { render, staticRenderFns } from "./SelectedFilter.vue?vue&type=template&id=297d59da"
import script from "./SelectedFilter.vue?vue&type=script&lang=js"
export * from "./SelectedFilter.vue?vue&type=script&lang=js"
import style0 from "./SelectedFilter.vue?vue&type=style&index=0&id=297d59da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports